import { useCallback, useEffect, useState } from 'react'
import { tasksApi } from '@carrent/api'

/**
 * Список задач с фильтрами.
 *
 * Загрузка, состояния и сборка параметров запроса — здесь.
 * Как это показать (таблица с сортировкой в консоли, лента
 * карточек у водителя) решает приложение.
 *
 * Прежняя версия глотала ошибку: `try { ... } finally { setLoading(false) }`
 * без catch — при падении запроса экран показывал «Задач нет».
 */
export function useTasks({ status = '', scope = 'all', perPage = 50 } = {}) {
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const load = useCallback(async () => {
    setLoading(true)
    setError('')
    try {
      const params = { parent_id: 'null', per_page: perPage }
      if (status) params.status = status
      if (scope === 'mine') params.assigned_to = 'me'
      if (scope === 'created') params.created_by = 'me'

      const { data } = await tasksApi.list(params)
      setTasks(data.data?.items || data.data || [])
    } catch (e) {
      setError(e.response?.data?.message || 'Не удалось загрузить задачи')
      setTasks([])
    } finally {
      setLoading(false)
    }
  }, [status, scope, perPage])

  useEffect(() => {
    load()
  }, [load])

  return { tasks, loading, error, reload: load }
}
